module.exports = __webpack_public_path__ + "img/click2fit.7d32749a.svg";